import { Theme, createStyles, Typography, makeStyles, Box } from '@material-ui/core';
import { grey } from '@material-ui/core/colors';
import React, { useEffect, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import { appVersion } from '../../config';
import { AppState } from '../../redux';
import { UserDescription } from '../../redux/users';
import { CURRENT_USER } from '../../utils/types';
import { getFullFormVersion } from '../components/NewEvalButton';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      bottom: 0,
      width: '100%',
      backgroundColor: grey[50],
      height: '20px',
      borderTopColor: grey[300],
      borderTopWidth: '1px',
      borderTopStyle: 'solid',
      display: 'flex',
      justifyContent: 'space-between'
    },
    footerLeft: {
      display: 'flex',
      justifyContent: 'flex-start',
      paddingLeft: theme.spacing(1),
      [theme.breakpoints.down("xs")]: {
        paddingLeft: theme.spacing(4),
      }
    },
    footerRight: {
      display: 'flex',
      justifyContent: 'flex-end',
      paddingRight: theme.spacing(1),
      [theme.breakpoints.down("xs")]: {
        paddingRight: theme.spacing(4),
      },
    }
  })
)

const selectCurrentUserFetched = createSelector(
  (state: AppState) => state.session.currentUserFetched, ready => ready
)

const selectActiveDefinition = createSelector(
  (state: AppState) => state.forms.activeFormDefinition, definition => definition
)

const AppFooter = (props: any) => {
  const { isSyncing } = props;
  
  const classes = useStyles(props);
  // todo just move current user into session state
  const currentUserFetched = useSelector(selectCurrentUserFetched);
  const [user, setUser] = useState<UserDescription | null>(null);
  const activeDefinition = useSelector(selectActiveDefinition, shallowEqual);
  const [activeDefinitionText, setActiveDefinitionText] = useState('');

  useEffect(() => {
    if (!activeDefinition) {
      return;
    }

    setActiveDefinitionText(getFullFormVersion(activeDefinition));

  }, [activeDefinition])

  useEffect(() => {
    if (!currentUserFetched) {
      setUser(null);
      return;
    }

    setUser(
      JSON.parse(localStorage.getItem(CURRENT_USER) as string)
    )
  }, [currentUserFetched])

  return (
    <div className={classes.root}>
      <div className={classes.footerLeft}>
        {user && (
          <Typography variant='caption'>
            {user!.name}
          </Typography>
        )}
        {isSyncing && (
          <Box ml={1}>
            <Typography variant='caption' color={'textSecondary'}>
              (Syncing...)
            </Typography>
          </Box>
        )}
      </div>

    <div className={classes.footerRight}>
        {activeDefinition
          ? (
            <React.Fragment>
              <Box mr={1}>
                <Typography variant='caption'>
                  Form - { activeDefinitionText }
                </Typography>
              </Box>

              <Typography variant='caption'>
                (App v{appVersion})
              </Typography>
            </React.Fragment>
          )
        : (
          <Typography variant='caption'>
            App v{appVersion}
          </Typography>
        )}

      </div>
    </div>
  )
}

export default AppFooter;